import { AccountStarIcon } from './AccountStarIcon';

/**
 * author: REJack
 * id 1E04960E-FFFE-439D-A5FD-C51E7291DA6F
 * name account-star
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-star.svg
 * tags
 * - Account / User 
 */
export const AccountFavoriteIcon = AccountStarIcon;
export default AccountFavoriteIcon